import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'globot-button',
  standalone: true,
  templateUrl: './button-globot.component.html',
  imports: [NgClass, NgIf],
  styleUrls: ['./button-globot.component.scss'],
})
export class ButtonGlobotComponent implements OnInit {
  @Input() text: string = '';

  @Input() icon: string = '';
  @Input() iconPosition: 'right' | 'left' = 'left';
  @Input() styleClass:
    | 'raised'
    | 'outline'
    | 'text'
    | 'facebook'
    | 'facebook-outline'
    | 'whatsapp'
    | 'instagram'
    | 'primary'
    | 'secondary' = 'raised';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() width:
    | 'w-100'
    | 'w-90'
    | 'w-80'
    | 'w-75'
    | 'w-66'
    | 'w-50'
    | 'w-33'
    | 'w-25'
    | 'w-auto'
    | '' = '';

  //Emiter
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

  style: string = '';

  onClickEvent(event: any): void {
    this.clickEvent.emit(event);
  }

  ngOnInit(): void {
    this.style = `${this.styleClass} ${this.width}`;
  }
}
